import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import PlaylistAddCheckRoundedIcon from "@mui/icons-material/PlaylistAddCheckRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { Box, Button, Typography } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  isFetching: boolean;
  selectedCount: number;
  showMailMergeButton: boolean;
  isWritingMailMerge: boolean;
  showCreateRecordsButton: boolean;
  isCreatingRecords: boolean;
  onLoadData: () => void;
  onCreateMailMerge: () => void;
  onCreateRecords: () => void;
}

export function EdictsHeader({
  isFetching,
  selectedCount,
  showMailMergeButton,
  isWritingMailMerge,
  showCreateRecordsButton,
  isCreatingRecords,
  onLoadData,
  onCreateMailMerge,
  onCreateRecords,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
      <Typography variant="h1">{t("edicts.title")}</Typography>
      <Box display="flex" alignItems="center" gap={1}>
        {showMailMergeButton && (
          <Button
            variant="outlined"
            startIcon={<MailOutlineRoundedIcon />}
            disabled={selectedCount === 0 || isWritingMailMerge}
            onClick={onCreateMailMerge}
          >
            {t("edicts.actions.createMailMerge", { value: selectedCount })}
          </Button>
        )}
        {showCreateRecordsButton && (
          <Button
            variant="outlined"
            startIcon={<PlaylistAddCheckRoundedIcon />}
            disabled={selectedCount === 0 || isCreatingRecords}
            onClick={onCreateRecords}
          >
            {t("edicts.actions.createAvAndTask", { value: selectedCount })}
          </Button>
        )}
        <Button variant="contained" startIcon={<RefreshRoundedIcon />} disabled={isFetching} onClick={onLoadData}>
          {t("edicts.actions.loadData")}
        </Button>
      </Box>
    </Box>
  );
}
